<script setup lang="ts">
import type { NovaBoxBoardListNoticeItemProps } from './NovaBoxBoardListNoticeItem.types'
import { ROUTES } from '@configs'

const props = defineProps<NovaBoxBoardListNoticeItemProps>()

const { date } = useDateFormat()
const { gtEvent } = useGoogleTag()

const onGoNoticeDetail = () => {
  try {
    let detailPath = ''

    switch (props.noticeType) {
      case 'news':
        detailPath = useRoutePathIdChange(ROUTES.BOARD_NEWS_DETAIL.path, {
          id: props.source.nttGroupId,
        })
        gtEvent('clickEvent', {
          eventCategory: '클릭',
          eventAction: '뉴스 목록 > 상세보기',
          eventLabel: props.source.nttSj,
          eventSlot: '',
          eventI18nAddr: props.source.nttSj,
          eventComponent: 'Button',
          nttGroupId: props.source.nttGroupId,
        })
        break
      case 'notice':
        detailPath = useRoutePathIdChange(ROUTES.BOARD_NOTICE_DETAIL.path, {
          id: props.source.nttGroupId,
        })
        gtEvent('clickEvent', {
          eventCategory: '클릭',
          eventAction: '공지사항 목록 > 상세보기',
          eventLabel: props.source.nttSj,
          eventSlot: '',
          eventI18nAddr: props.source.nttSj,
          eventComponent: 'Button',
          nttGroupId: props.source.nttGroupId,
        })
        break
      case 'event':
        detailPath = useRoutePathIdChange(ROUTES.BOARD_EVENT_DETAIL.path, {
          id: props.source.nttGroupId,
        })
        gtEvent('clickEvent', {
          eventCategory: '클릭',
          eventAction: '이벤트 목록 > 상세보기',
          eventLabel: props.source.nttSj,
          eventSlot: '',
          eventI18nAddr: props.source.nttSj,
          eventComponent: 'Button',
          nttGroupId: props.source.nttGroupId,
        })
        break
      case 'faq':
        detailPath = useRoutePathIdChange(ROUTES.BOARD_FAQ_DETAIL.path, {
          id: props.source.nttGroupId,
        })
        gtEvent('clickEvent', {
          eventCategory: '클릭',
          eventAction: '자주 묻는 질문 목록 > 상세보기',
          eventLabel: props.source.nttSj,
          eventSlot: '',
          eventI18nAddr: props.source.nttSj,
          eventComponent: 'Button',
          nttGroupId: props.source.nttGroupId,
        })
        break
      case 'funding':
        detailPath = useRoutePathIdChange(ROUTES.FUND_NOTICE_DETAIL.path, {
          id: props.source.nttGroupId,
        })
        gtEvent('clickEvent', {
          eventCategory: '클릭',
          eventAction: '펀드 공지사항 목록 > 상세보기',
          eventLabel: props.source.nttSj,
          eventSlot: '',
          eventI18nAddr: props.source.nttSj,
          eventComponent: 'Button',
          nttGroupId: props.source.nttGroupId,
        })
        break
      case 'w3cf-notice':
        throw new Error('w3cf-notice index page not exist')
      default:
        throw new Error('notice type is not match')
    }
    useNavigations({ url: detailPath })
  } catch (err: unknown) {
    if (err instanceof Error) {
      console.error(err.message)
    }
  }
}
</script>

<template>
  <button type="button" class="list-item" @click="onGoNoticeDetail">
    <div class="list-header">
      <span class="title-box">
        <em class="title">
          {{
            source.nttNoticeAt === 'Y' ? `[${$t('board.label.notice')}]` : ''
          }}
          {{ source.nttSj }}
        </em>

        <em class="date">
          {{ date({ date: source.sysRegistDt, format: 'YYYY-MM-DD' }) }}
        </em>
      </span>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.list-item {
  padding: 30px 20px;
  background-color: $color-white;
  border-radius: $radius-10;
  width: 100%;
  text-align: left;

  .list-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title-box {
      display: flex;
      flex-direction: column;
      gap: 6px;
      width: 100%;

      em {
        display: block;
        @include text-style($text-heading3-medium);
      }

      .title {
        @include ellipsis(1);
      }

      .date {
        @include text-style($text-body-12-regular);
        line-height: 14px;
        color: $color-text-3;
      }
    }

    .icon-button {
      display: block;
      width: 20px;
      height: 20px;
      color: $color-text-3;

      @include transition(transform 0.2s);

      &.open {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
